exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-3b4665cb]{padding:0;margin:0 0 35px;border-bottom:0}h6.head-title[data-v-3b4665cb]{margin-bottom:20px;font-size:1.1rem}.modal-footer[data-v-3b4665cb]{padding:0;margin-top:18px;border:0}.form-group[data-v-3b4665cb]{margin-bottom:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3b4665cb","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/employee/modals/DisableSyncEmployeeModal.vue
// module id = C3kp
// module chunks = 0